//// Configuracion de Desarrollo //////
//// No modificar ************** //////
export const AuthApi = "https://devauthapi.netizar.com/api/";
export const UrlApi = "https://devapi.netizar.com/api";
export const MailApi = "https://uservices.netizar.com";
export const SmsApi = "https://sms.netizar.com/api";
export const titulonavbar = "DevExt";
export const UrlApp = "http://dev.netizar.com:3000/";
export const UrlPortalProveedores = "http://devproveedores.netizar.com";
export const UrlApiEnvasado = "https://apienvasado.netizar.com/";
export const UrlFacturacion = "http://192.168.0.22:8122"; /// 8122 es el puerto para desarrollo
export const TelemetriaApi = "https://192.168.0.22:3536/api";
////////////////////////////////////////